// export const DOMAIN = "http://localhost:4000"; // hoặc domain thật
// export const DOMAIN = "https://api.elephant.kakiem.observer"; // Hieu
export const DOMAIN = "https://api.elephant.nam.kakiem.observer"; // Nam
// export const DOMAIN = "https://api.elephant.bro.kakiem.observer"; // anh Nam
// export const DOMAIN = "https://api.elephant.friend.kakiem.observer"; // anh Tình
export const DOMAIN_AUTH = `${DOMAIN}/api/auth`;
export const DOMAIN_FB = `${DOMAIN}/api/fb/`;